import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '../../../../components/lists/list-item/list-item';
import { DataVariant, ListItemData } from '../../../../components/lists/list-item/types';
import { formatDate } from '../../../../helpers/date-formatters';
import { formatNumber } from '../../../../helpers/number-formatters';
import { CurrencyConversionListItem as ListItemDataInput } from '../../../../logic/graphql/types/types.d';
import { Paths } from '../../../../navigation/paths';
import { useIntl } from 'react-intl';

const CurrencyConversionListItem = (props: {
  listItem: ListItemDataInput;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const history = useHistory();
  const intl = useIntl();

  const handleOnClick = (): void => {
    history.push(Paths.currency_conversions + '/' + props.listItem.transaction_code);
  };

  const exchangeRateDescriptor =
    (props.listItem.from_currency.currency || '') +
    ' / ' +
    (props.listItem.to_currency.currency || '');

  const data: ListItemData = {
    status: props.listItem.status,
    iconVisible: true,
    title: props.listItem.from_currency.currency + ' - ' + props.listItem.to_currency.currency,
    transactionCode: props.listItem.transaction_code,
    detailBlocks: [
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'currencyConversions.listItem.fromAmount' }),
            value: formatNumber(props.listItem.from_amount, props.listItem.from_currency.currency),
            variant: DataVariant.highlighted,
          },
        ],
      },
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'currencyConversions.listItem.toAmount' }),
            value: formatNumber(props.listItem.to_amount, props.listItem.to_currency.currency),
          },
          {
            label: intl.formatMessage({ id: 'currencyConversions.listItem.exchangeRate' }),
            value: formatNumber(props.listItem.exchange_rate, exchangeRateDescriptor),
          },
        ],
      },
    ],
    date: formatDate(props.listItem.order_date),
  };

  return (
    <ListItem
      onClick={handleOnClick}
      data={data}
      style={props.style}
      mobileHeight={props.mobileHeight}
    />
  );
};

export default CurrencyConversionListItem;
